var _rect, _rect2, _rect3, _rect4, _rect5, _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuture2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 494,
    viewBox: "0 0 208 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 208 3)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 71 112)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 208 215)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 71 324)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 68,
    height: 67,
    rx: 16.5,
    transform: "matrix(-1 0 0 1 208 427)",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 358.667H20.6665V356H23.3332",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6665 358.667H51.3332V356H48.6665",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 356H30",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 358.667H42",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 353C23.3335 352.558 23.5091 352.134 23.8217 351.821C24.1342 351.509 24.5581 351.333 25.0002 351.333C25.4422 351.333 25.8661 351.509 26.1787 351.821C26.4912 352.134 26.6668 352.558 26.6668 353V362.333C26.6668 362.775 26.4912 363.199 26.1787 363.512C25.8661 363.824 25.4422 364 25.0002 364C24.5581 364 24.1342 363.824 23.8217 363.512C23.5091 363.199 23.3335 362.775 23.3335 362.333V353Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 350.333C26.6665 349.891 26.8421 349.467 27.1547 349.155C27.4672 348.842 27.8911 348.667 28.3332 348.667C28.7752 348.667 29.1991 348.842 29.5117 349.155C29.8242 349.467 29.9998 349.891 29.9998 350.333V364.333C29.9998 364.775 29.8242 365.199 29.5117 365.512C29.1991 365.824 28.7752 366 28.3332 366C27.8911 366 27.4672 365.824 27.1547 365.512C26.8421 365.199 26.6665 364.775 26.6665 364.333V350.333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6668 353C48.6668 352.558 48.4912 352.134 48.1787 351.821C47.8661 351.509 47.4422 351.333 47.0002 351.333C46.5581 351.333 46.1342 351.509 45.8217 351.821C45.5091 352.134 45.3335 352.558 45.3335 353V362.333C45.3335 362.775 45.5091 363.199 45.8217 363.512C46.1342 363.824 46.5581 364 47.0002 364C47.4422 364 47.8661 363.824 48.1787 363.512C48.4912 363.199 48.6668 362.775 48.6668 362.333V353Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 350.333C45.3333 349.891 45.1577 349.467 44.8452 349.155C44.5326 348.842 44.1087 348.667 43.6667 348.667C43.2246 348.667 42.8007 348.842 42.4882 349.155C42.1756 349.467 42 349.891 42 350.333V364.333C42 364.775 42.1756 365.199 42.4882 365.512C42.8007 365.824 43.2246 366 43.6667 366C44.1087 366 44.5326 365.824 44.8452 365.512C45.1577 365.199 45.3333 364.775 45.3333 364.333V350.333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1354_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3335 130H47.6668",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 138.667L37.6667 136.667L38.3333 134L39.6667 133.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 152H19.6665V157.333H34.9998V152Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3332 146.667H27.6665V152H42.3332V146.667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6665 146.667H19.6665V152H27.6665V146.667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 152H35V157.333H50.3333V152Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 130C50.3333 129.562 50.2471 129.129 50.0796 128.724C49.9121 128.32 49.6666 127.953 49.357 127.643C49.0475 127.334 48.68 127.088 48.2756 126.92C47.8712 126.753 47.4377 126.667 47 126.667C46.3847 126.668 45.7819 126.841 45.26 127.167L39 132L40.3333 134.667C40.3333 134.667 47.5467 133.287 47.7467 133.24C48.4803 133.071 49.1353 132.659 49.605 132.071C50.0747 131.483 50.3314 130.753 50.3333 130V130Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 142.667L33.6667 132.667L37.6667 142.667H23Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1354_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.333 264C182.752 264 186.333 260.418 186.333 256C186.333 251.582 182.752 248 178.333 248C173.915 248 170.333 251.582 170.333 256C170.333 260.418 173.915 264 178.333 264Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.667 248.267C185.757 246.854 186.343 245.118 186.333 243.333C186.309 241.042 185.388 238.852 183.768 237.232C182.148 235.612 179.958 234.691 177.667 234.667C176.372 234.66 175.093 234.958 173.935 235.537C172.777 236.116 171.771 236.96 171 238C170.228 236.96 169.223 236.116 168.065 235.537C166.906 234.958 165.628 234.66 164.333 234.667C162.042 234.691 159.852 235.612 158.232 237.232C156.612 238.852 155.691 241.042 155.667 243.333C155.668 244.46 155.902 245.575 156.354 246.607C156.806 247.64 157.466 248.568 158.293 249.333C159.627 250.713 167.86 259.333 170.293 261.927",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.333 253.36L177 258.64L174.333 255.973",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1354_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.666 33V50.3333C162.658 50.5982 162.704 50.862 162.802 51.1084C162.899 51.3549 163.046 51.5787 163.234 51.7661C163.421 51.9535 163.645 52.1005 163.891 52.1981C164.138 52.2956 164.402 52.3417 164.666 52.3333H178C178.265 52.3417 178.529 52.2956 178.775 52.1981C179.021 52.1005 179.245 51.9535 179.433 51.7661C179.62 51.5787 179.767 51.3549 179.865 51.1084C179.962 50.862 180.008 50.5982 180 50.3333V33",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.333 43.6667V38.3333C191.333 37.4493 190.982 36.6014 190.357 35.9763C189.732 35.3512 188.884 35 188 35C187.116 35 186.268 35.3512 185.643 35.9763C185.018 36.6014 184.667 37.4493 184.667 38.3333V43.6667C184.667 44.5507 185.018 45.3986 185.643 46.0237C186.268 46.6488 187.116 47 188 47C188.884 47 189.732 46.6488 190.357 46.0237C190.982 45.3986 191.333 44.5507 191.333 43.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.333 41H191.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 41.6667H173.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 38.3333H170.667",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 21.6667H160.667V31.0001H182V21.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1354_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.302 460.913C173.796 460.913 175.008 459.702 175.008 458.207C175.008 456.713 173.796 455.501 172.302 455.501C170.807 455.501 169.596 456.713 169.596 458.207C169.596 459.702 170.807 460.913 172.302 460.913Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.979 460.913L177.714 475.797",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.625 460.913L166.89 475.797",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.596 467.679H175.008",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.243 472.414H176.361",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.614 465.696C165.985 464.7 164.724 463.201 164.023 461.425C163.321 459.649 163.217 457.693 163.725 455.853C164.233 454.012 165.326 452.387 166.84 451.223C168.353 450.059 170.204 449.419 172.113 449.399C174.023 449.38 175.886 449.982 177.423 451.116C178.96 452.249 180.086 453.851 180.631 455.681C181.177 457.511 181.112 459.469 180.446 461.258C179.781 463.048 178.551 464.573 176.943 465.602",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.424 470.216C181.124 468.819 183.276 466.554 184.531 463.786C185.787 461.017 186.073 457.907 185.345 454.955C184.617 452.004 182.916 449.384 180.516 447.517C178.117 445.651 175.159 444.647 172.119 444.667C169.079 444.687 166.135 445.73 163.76 447.628C161.386 449.526 159.719 452.169 159.03 455.129C158.341 458.09 158.669 461.197 159.961 463.948C161.253 466.7 163.434 468.936 166.152 470.297",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18.6667,
    fill: "white",
    transform: "translate(20 348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1354_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1354_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.6667,
    fill: "white",
    transform: "translate(155 234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1354_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(160 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1354_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4144,
    height: 32,
    fill: "white",
    transform: "translate(158 444)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture2);
export default __webpack_public_path__ + "static/media/future2.045a36672ca5e733260c8a95570e583e.svg";
export { ForwardRef as ReactComponent };